@if (proposal.proposalState === 'POLICY_CREATED') {
  @if (proposal?.policyDetails?.offerId && hasLead) {
    <app-expansion-panel
      i18n-title
      title="Message d'acceptation"
      [collapsed]="true"
    >
      <div class="mt-12">
        <app-policy-acceptation-message-content [proposal]="proposal" />
      </div>
    </app-expansion-panel>
  }
} @else {
  <app-card>
    <div cardRows>
      <div class="card__value">
        <app-policy-acceptation-message-content [proposal]="proposal" />
      </div>
    </div>
  </app-card>
}
